export type RouteAccessDecision =
  | { state: "loading" }
  | { state: "allow" }
  | { state: "redirect"; destination: "/login" };

export function isProtectedRoute(pathname: string) {
  return (
    pathname === "/app" ||
    pathname.startsWith("/app/") ||
    pathname.startsWith("/customers/") ||
    pathname === "/support" ||
    pathname.startsWith("/support/")
  );
}

export function decideRouteAccess(input: {
  pathname: string;
  isLoading: boolean;
  isAuthenticated: boolean;
}): RouteAccessDecision {
  if (!isProtectedRoute(input.pathname)) return { state: "allow" };
  if (input.isLoading) return { state: "loading" };
  if (!input.isAuthenticated) {
    return { state: "redirect", destination: "/login" };
  }
  return { state: "allow" };
}
